import React, { useEffect, useMemo, useRef, useState } from 'react';
import { openBrowser } from '@/utils/native';
import { getIncomeSource } from '@/utils/vip';
import { TrackData } from '@/page/subscription';
import styles from './index.module.css';
import { isTeamSubscription, SubscribeType, subscribeType } from '@/constants';

interface IProps {
  text: string;
  showBtn?: boolean;
  track?: (data: TrackData) => void;
}
const Notify: React.FC<IProps> = (props) => {
  const { text, track, showBtn } = props;
  const marqueeRef = useRef<HTMLDivElement>(null);
  const measureRef = useRef<HTMLSpanElement>(null);
  const [repeatCount, setRepeatCount] = useState(2);

  const hasTabs = useMemo(() => {
    if (
      isTeamSubscription ||
      (subscribeType !== SubscribeType.MEIDOU && subscribeType !== SubscribeType.SUBSCRIPTION)
    ) {
      return false;
    }

    return true;
  }, []);

  const handleJump = () => {
    const isMtxxWeb = getIncomeSource() === 'MTXX-WEB';

    const params: any = {};
    if (isMtxxWeb) {
      window.open('https://oc.meitu.com/mtxx-pro/4081/index.html');
      params.class = 'notice';
    } else {
      openBrowser('https://oc.meitu.com/mtxx-pro/4081/index.html');
      params.category = '公告详情';
    }

    track?.({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params,
    });
  };

  useEffect(() => {
    const updateRepeatCount = () => {
      const marqueeWidth = marqueeRef.current?.offsetWidth ?? 0;
      const contentWidth = measureRef.current?.offsetWidth ?? 0;

      if (!marqueeWidth || !contentWidth) {
        setRepeatCount(2);
        return;
      }

      // Keep one segment wider than the viewport so the duplicated segment
      // can connect seamlessly without exposing empty space.
      const nextRepeatCount = Math.max(2, Math.ceil(marqueeWidth / contentWidth) + 1);
      setRepeatCount(nextRepeatCount);
    };

    updateRepeatCount();

    const resizeObserver =
      typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateRepeatCount) : null;

    if (resizeObserver) {
      if (marqueeRef.current) {
        resizeObserver.observe(marqueeRef.current);
      }
      if (measureRef.current) {
        resizeObserver.observe(measureRef.current);
      }
    } else {
      window.addEventListener('resize', updateRepeatCount);
    }

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener('resize', updateRepeatCount);
    };
  }, [text]);

  const renderContent = (hidden?: boolean) =>
    Array.from({ length: repeatCount }).map((_, index) => (
      <span key={`${hidden ? 'copy' : 'main'}-${index}`} aria-hidden={hidden}>
        {text}
      </span>
    ));

  return (
    <div className={styles.module} style={{ marginBottom: hasTabs ? -10 : 0 }}>
      <div className={styles.marquee} ref={marqueeRef}>
        <div className={styles.marqueeTrack}>
          <div className={styles.marqueeContent}>{renderContent()}</div>
          <div className={styles.marqueeContent} aria-hidden="true">
            {renderContent(true)}
          </div>
        </div>
        <span className={styles.measureText} ref={measureRef}>
          {text}
        </span>
      </div>
      {showBtn && (
        <div className={styles.btn} onClick={handleJump}>
          查看详情
        </div>
      )}
    </div>
  );
};

export default React.memo(Notify);
